import { CatalogueType } from '@/config/types'

export function getFooterColumnTitleTags(catalogueType?: CatalogueType): string[] {
  if (catalogueType === 'winter') {
    return [
      'footer_winter_column1_title',
      'footer_winter_column2_title',
      'footer_winter_column3_title',
    ]
  }

  if (!catalogueType) {
    return [
      'footer_splash_column1_title',
      'footer_splash_column2_title',
      'footer_splash_column3_title',
    ]
  }

  return [
    'footer_summer_column1_title',
    'footer_summer_column2_title',
    'footer_summer_column3_title',
  ]
}
